import { createFileRoute } from '@tanstack/react-router'
import ProjectInfoPanel from '../../../../../../components/project-info-panel'
import { infoSearchSchema } from '../../search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/_projects/info/$projectId/'
)({
  component: ProjectInfoPanel,
  validateSearch: infoSearchSchema
})
